/*
Monotype Foundry Platform API
Version 1.0.0

Definition: PatchInventoryIngestionRequest

Properties:
  projectName: string (required), minLength: 3, maxLength: 100
  mId: string
  ingestionNotes: array
*/

var PatchInventoryIngestionRequest = (function () {
  function validatePatchInventoryIngestionRequest (arg) {
    // Validate projectName
    if (!arg.projectName) {
      throw new Error('PatchInventoryIngestionRequest.projectName: Missing property')
    }
    if (arg.projectName && !(typeof arg.projectName === 'string')) {
      throw new Error('PatchInventoryIngestionRequest.projectName: Wrong type: Got \'' + (typeof arg.projectName) + '\', but expected: \'string\'')
    }
    if (arg.projectName && !(arg.projectName.length >= 3)) {
      throw new Error('PatchInventoryIngestionRequest.projectName: Minimum length 3, but got: ' + arg.projectName.length)
    }
    if (arg.projectName && !(arg.projectName.length <= 100)) {
      throw new Error('PatchInventoryIngestionRequest.projectName: Maximum length 100, but got: ' + arg.projectName.length)
    }
    // Validate mId
    if (arg.mId && !(typeof arg.mId === 'string')) {
      throw new Error('PatchInventoryIngestionRequest.mId: Wrong type: Got \'' + (typeof arg.mId) + '\', but expected: \'string\'')
    }
    // Validate ingestionNotes
    if (arg.ingestionNotes && !(Array.isArray(arg.ingestionNotes))) {
      throw new Error('PatchInventoryIngestionRequest.ingestionNotes: Wrong type: Got \'' + (typeof arg.ingestionNotes) + '\', but expected: \'array\'')
    }
  }
  function buildPatchInventoryIngestionRequest (arg) {
    var PatchInventoryIngestionRequest = arg
    // Complete projectName
    // Expected Type: string
    PatchInventoryIngestionRequest.projectName = PatchInventoryIngestionRequest.projectName || ''
    // Complete mId
    // Expected Type: string
    PatchInventoryIngestionRequest.mId = PatchInventoryIngestionRequest.mId || ''
    // Complete ingestionNotes
    // Expected Type: array
    PatchInventoryIngestionRequest.ingestionNotes = PatchInventoryIngestionRequest.ingestionNotes || []
    return PatchInventoryIngestionRequest
  }
  return {
    validate: validatePatchInventoryIngestionRequest,
    build: buildPatchInventoryIngestionRequest
  }
})()

module.exports = PatchInventoryIngestionRequest
